export default __webpack_public_path__ + "static/media/coins-grey.98449aa9.png";